import { Injectable } from '@angular/core'
import {
   ISubscriptionAuthorization,
   ISubscriptionConversionOption,
   ISubscriptionPaymentTransaction
} from '@appShared/interfaces/[Model-based]'

@Injectable({
   providedIn: 'root'
})
export class MockDataService {

   public getSubscriptionAuthorizations(): ISubscriptionAuthorization[] {
      return [
         {
            "$id": "1",
            "id": 948,
            "subscriptionId": 2260,
            "paymentInstrumentId": 907,
            "amount": 99.0000,
            "isTaxable": false,
            "confirmationCode": "B64BC",
            "confirmationPhoneNumber": null,
            "confirmationEmailAddress": null,
            "confirmedFromIpAddress": "104.22.1.145",
            "confirmed": "2/5/2026 7:19:13 AM -06:00",
            "deactivated": null,
            "auditId": "35f42877-1dc2-4288-b362-05ad387206b9",
            "version": "AAAAAAJ9NC4=",
            "paymentInstrument": {
               "$id": "2",
               "info": {
                  "currencyDescription": "America (United States of America), Dollars",
                  "currencyShortDescription": "$",
                  "typeDescription": "Payment Card",
                  "isTokenized": true,
                  "eft": null,
                  "card": {
                     "typeCode": 1,
                     "typeDescription": "MasterCard",
                     "typeLiteral": "MasterCard",
                     "cardholderName": "Aleah LeadTest",
                     "pan": "***4444",
                     "expiration": "12/31/2027 12:00:00 AM",
                     "cvv2": null
                  }
               },
               "id": 907,
               "contactId": 3151,
               "walletContactId": 3150,
               "currencyCode": 1,
               "typeCode": 2,
               "sourceName": "MasterCard",
               "lastFour": "4444",
               "token": "cGF5bWVudG1ldGhvZF9jY19iZ3o5MXBhYg",
               "tokenReference": "bgz91pab",
               "tokenReceipt": "8d54b799-26a4-4edd-9b23-35d0e844b43e",
               "tokenizationRequestTicket": "1381fcae-9675-43d7-9348-a6af5a271651",
               "tokenized": "2/5/2026 7:04:06 AM -06:00",
               "deactivated": null,
               "auditId": "b2033f4d-6761-43a8-b825-d03954710599",
               "version": "AAAAAAJ8Yhg=",
               "contact": {
                  "$id": "3",
                  "info": {
                     "displayName": "",
                     "isLocalIdentity": false,
                     "nickname": null,
                     "userPrincipalId": null,
                     "userPrincipalName": null,
                     "userObjectIdentifier": null
                  },
                  "id": 3151,
                  "lastName": null,
                  "firstName": null,
                  "legalName": "Aleah LeadTest",
                  "emailAddress": null,
                  "canRegister": false,
                  "auditId": "4b5e6f47-d9e3-46f4-8d64-4ebd7daf26b5",
                  "version": "AAAAAAJ8YhU=",
                  "paymentInstrumentContact": {
                     "$ref": "2"
                  },
                  "contactAddresses": [],
                  "contactCertificates": [],
                  "contactIdentityClaims": [],
                  "contactPartitionProgresses": [],
                  "contentRegistrations": [],
                  "notifications": [],
                  "paymentInstrumentWalletContacts": [],
                  "profiles": []
               },
               "walletContact": null,
               "eftRecord": null,
               "paymentCard": {
                  "id": 642,
                  "paymentInstrumentId": 907,
                  "typeCode": 1,
                  "expiration": "12/31/2027 12:00:00 AM",
                  "paymentInstrument": {
                     "$ref": "2"
                  }
               },
               "paymentCardMaintenanceDetails": [],
               "paymentTransactions": [],
               "subscriptionAuthorizations": [
                  {
                     "$ref": "1"
                  }
               ]
            },
            "subscription": {
               "$id": "4",
               "info": {
                  "hasActiveSubscriptionAuthorization": true,
                  "isOnRenewalProbation": false,
                  "isPendingCancellation": false,
                  "isPendingPause": false,
                  "accountOwnerProfile": null,
                  "activeSubscriptionAuthorization": {
                     "$ref": "1"
                  },
                  "relevantSubscriptionAuthorization": {
                     "$ref": "1"
                  },
                  "subscriptionProductPartionContainerId": 0
               },
               "id": 2260,
               "accountId": 2069,
               "productId": 1,
               "productRegistered": "2/5/2026 12:00:00 AM",
               "referenceSourceId": "54552816",
               "sourceCode": 1,
               "partnerRepresentativeId": 40298,
               "statusCode": 1,
               "seatLimit": 6,
               "activated": "2/5/2026 7:19:05 AM -06:00",
               "lastPaymentAttempted": "5/6/2026 4:45:47 PM -05:00",
               "retryAttempts": 0,
               "nextPaymentDue": "6/5/2026 12:00:00 AM",
               "renewalProbationEffective": null,
               "expires": null,
               "cancelled": null,
               "cancellationEffective": null,
               "pausedUntil": null,
               "cancellationReasonCode": null,
               "cancellationSourceCode": null,
               "cancellationReasonText": null,
               "productVariantSourceId": null,
               "auditId": "cc40d18f-1ca6-4a63-b247-88d5a7949aba",
               "version": "AAAAAAJ+CFc=",
               "account": null,
               "partnerRepresentative": null,
               "product": {
                  "$id": "5",
                  "info": {
                     "forRenewalOnly": false
                  },
                  "id": 1,
                  "partnerId": 131073,
                  "registrationTenantId": 2,
                  "billingFrequencyCode": 1,
                  "classCode": 1,
                  "sourceId": "LEM",
                  "displayName": "LEAD Monthly",
                  "defaultConversionSourceId": null,
                  "autoRenewalExpirationInMonths": null,
                  "defaultSeatLimit": 6,
                  "auditId": "609dd865-633b-4c9c-89a4-164f945924d9",
                  "version": "AAAAAAJ+J4Y=",
                  "partner": null,
                  "registrationTenant": null,
                  "accountingRules": [],
                  "productPartitions": [],
                  "subscriptions": [
                     {
                        "$ref": "4"
                     }
                  ]
               },
               "subscriptionAuthorizations": [
                  {
                     "$ref": "1"
                  }
               ],
               "subscriptionConversionOptions": [],
               "subscriptionPaymentTransactionTransactions": [],
               "subscriptionSeats": []
            }
         }
      ] as unknown as ISubscriptionAuthorization[]
   }

   public getSubscriptionPaymentTransactions(): ISubscriptionPaymentTransaction[] {
      return [
         {
            "$id": "1",
            "id": 5849,
            "subscriptionId": 2260,
            "paymentTransactionId": 5861,
            "salesTaxAreaSourceId": null,
            "salesTaxRate": null,
            "salesTaxAmount": null,
            "auditId": "c0b0fce8-6f8f-4464-8f69-27b0f9d9f898",
            "paymentTransaction": {
               "$id": "2",
               "id": 5861,
               "paymentInstrumentId": 907,
               "paymentGatewayCode": 6,
               "typeCode": 2,
               "statusCode": 1,
               "amount": 99.0000,
               "sourceId": "dHJhbnNhY3Rpb25fbTR2ZzV0YnM",
               "referenceSourceId": null,
               "paymentMerchantSourceId": "15",
               "responseMessage": "Loser with No Money",
               "responseRaw": "{\"id\":\"dHJhbnNhY3Rpb25fbTR2ZzV0YnM\",\"legacyId\":\"m4vg5tbs\",\"createdAt\":\"2026-05-06T21:45:47.000000Z\",\"paymentMethodSnapshot\":{\"brandCode\":\"MASTERCARD\",\"last4\":\"4444\",\"bin\":\"555555\",\"expirationMonth\":\"12\",\"expirationYear\":\"2027\",\"cardholderName\":\"Aleah LeadTest\",\"uniqueNumberIdentifier\":\"60f13b8a1e4a24fe2bf9e19a732169d6\",\"origin\":null},\"paymentMethod\":{\"id\":\"cGF5bWVudG1ldGhvZF9jY19iZ3o5MXBhYg\",\"legacyId\":\"bgz91pab\",\"usage\":\"MULTI_USE\",\"createdAt\":\"2026-02-05T13:04:06.000000Z\",\"customer\":{\"id\":\"Y3VzdG9tZXJfMTg1MjY4NzM2NTM\",\"legacyId\":\"18526873653\",\"createdAt\":\"2026-02-05T13:04:06.000000Z\",\"email\":null,\"firstName\":null,\"lastName\":null,\"phoneNumber\":null}},\"amount\":{\"value\":99.00,\"currencyIsoCode\":\"USD\"},\"orderId\":\"54552816-202605\",\"purchaseOrderNumber\":null,\"status\":\"SUBMITTED_FOR_SETTLEMENT\",\"riskData\":null,\"descriptor\":null,\"statusHistory\":[{\"status\":\"SUBMITTED_FOR_SETTLEMENT\",\"timestamp\":\"2026-05-06T21:45:47.000000Z\",\"amount\":{\"value\":99.00,\"currencyIsoCode\":\"USD\"},\"source\":\"API\",\"terminal\":false,\"declineType\":null,\"gatewayRejectionReason\":null,\"processorResponse\":null},{\"status\":\"AUTHORIZED\",\"timestamp\":\"2026-05-06T21:45:47.000000Z\",\"amount\":{\"value\":99.00,\"currencyIsoCode\":\"USD\"},\"source\":\"API\",\"terminal\":false,\"declineType\":null,\"gatewayRejectionReason\":null,\"processorResponse\":{\"legacyCode\":\"1000\",\"message\":\"Approved\",\"cvvResponse\":\"NOT_PROVIDED\",\"avsPostalCodeResponse\":\"MATCHES\",\"avsStreetAddressResponse\":\"MATCHES\",\"authorizationId\":\"W5943K\"}}],\"merchantAccountId\":\"SWAdvantage_Residual_PaymentCard_USD\",\"channel\":null,\"source\":\"API\",\"customer\":{\"id\":\"Y3VzdG9tZXJfMTg1MjY4NzM2NTM\",\"legacyId\":\"18526873653\",\"createdAt\":\"2026-02-05T13:04:06.000000Z\",\"email\":null,\"firstName\":null,\"lastName\":null,\"phoneNumber\":null}}",
               "approvalCode": "W5943K",
               "effective": "5/6/2026 4:45:47 PM -05:00",
               "auditId": "65294060-0005-4988-bba0-a6265b1fe963",
               "version": "AAAAAAJ+CFY=",
               "paymentInstrument": {
                  "$id": "3",
                  "info": {
                     "currencyDescription": "America (United States of America), Dollars",
                     "currencyShortDescription": "$",
                     "typeDescription": "Payment Card",
                     "isTokenized": true,
                     "eft": null,
                     "card": {
                        "typeCode": 1,
                        "typeDescription": "MasterCard",
                        "typeLiteral": "MasterCard",
                        "cardholderName": "Aleah LeadTest",
                        "pan": "***4444",
                        "expiration": "12/31/2027 12:00:00 AM",
                        "cvv2": null
                     }
                  },
                  "id": 907,
                  "contactId": 3151,
                  "walletContactId": 3150,
                  "currencyCode": 1,
                  "typeCode": 2,
                  "sourceName": "MasterCard",
                  "lastFour": "4444",
                  "token": "cGF5bWVudG1ldGhvZF9jY19iZ3o5MXBhYg",
                  "tokenReference": "bgz91pab",
                  "tokenReceipt": "8d54b799-26a4-4edd-9b23-35d0e844b43e",
                  "tokenizationRequestTicket": "1381fcae-9675-43d7-9348-a6af5a271651",
                  "tokenized": "2/5/2026 7:04:06 AM -06:00",
                  "deactivated": null,
                  "auditId": "b2033f4d-6761-43a8-b825-d03954710599",
                  "version": "AAAAAAJ8Yhg=",
                  "contact": {
                     "$id": "4",
                     "info": {
                        "displayName": "",
                        "isLocalIdentity": false,
                        "nickname": null,
                        "userPrincipalId": null,
                        "userPrincipalName": null,
                        "userObjectIdentifier": null
                     },
                     "id": 3151,
                     "lastName": null,
                     "firstName": null,
                     "legalName": "Aleah LeadTest",
                     "emailAddress": null,
                     "canRegister": false,
                     "auditId": "4b5e6f47-d9e3-46f4-8d64-4ebd7daf26b5",
                     "version": "AAAAAAJ8YhU=",
                     "paymentInstrumentContact": {
                        "$ref": "3"
                     },
                     "contactAddresses": [],
                     "contactCertificates": [],
                     "contactIdentityClaims": [],
                     "contactPartitionProgresses": [],
                     "contentRegistrations": [],
                     "notifications": [],
                     "paymentInstrumentWalletContacts": [],
                     "profiles": []
                  },
                  "walletContact": null,
                  "eftRecord": null,
                  "paymentCard": {
                     "id": 642,
                     "paymentInstrumentId": 907,
                     "typeCode": 1,
                     "expiration": "12/31/2027 12:00:00 AM",
                     "paymentInstrument": {
                        "$ref": "3"
                     }
                  },
                  "paymentCardMaintenanceDetails": [],
                  "paymentTransactions": [
                     {
                        "$ref": "2"
                     }
                  ],
                  "subscriptionAuthorizations": []
               },
               "paymentTransactionIntegration": null,
               "subscriptionPaymentTransactionTransaction": {
                  "$ref": "1"
               }
            },
            "subscription": {
               "$id": "5",
               "info": {
                  "hasActiveSubscriptionAuthorization": false,
                  "isOnRenewalProbation": false,
                  "isPendingCancellation": false,
                  "isPendingPause": false,
                  "accountOwnerProfile": null,
                  "activeSubscriptionAuthorization": null,
                  "relevantSubscriptionAuthorization": null,
                  "subscriptionProductPartionContainerId": 0
               },
               "id": 2260,
               "accountId": 2069,
               "productId": 1,
               "productRegistered": "2/5/2026 12:00:00 AM",
               "referenceSourceId": "54552816",
               "sourceCode": 1,
               "partnerRepresentativeId": 40298,
               "statusCode": 1,
               "seatLimit": 6,
               "activated": "2/5/2026 7:19:05 AM -06:00",
               "lastPaymentAttempted": "5/6/2026 4:45:47 PM -05:00",
               "retryAttempts": 0,
               "nextPaymentDue": "6/5/2026 12:00:00 AM",
               "renewalProbationEffective": null,
               "expires": null,
               "cancelled": null,
               "cancellationEffective": null,
               "pausedUntil": null,
               "cancellationReasonCode": null,
               "cancellationSourceCode": null,
               "cancellationReasonText": null,
               "productVariantSourceId": null,
               "auditId": "cc40d18f-1ca6-4a63-b247-88d5a7949aba",
               "version": "AAAAAAJ+CFc=",
               "account": {
                  "$id": "6",
                  "info": {},
                  "id": 2069,
                  "partnerId": 131073,
                  "sourceId": "0b8b3ae5935c4256836725b3b8dd25de",
                  "ownerProfileSourceId": "8f696233684c4669a87ccc7cdda2a0f3",
                  "auditId": "3234d1d1-5912-4595-9377-9525eb9c0118",
                  "partner": null,
                  "profiles": [],
                  "subscriptions": [
                     {
                        "$ref": "5"
                     }
                  ]
               },
               "partnerRepresentative": null,
               "product": {
                  "$id": "7",
                  "info": {
                     "forRenewalOnly": false
                  },
                  "id": 1,
                  "partnerId": 131073,
                  "registrationTenantId": 2,
                  "billingFrequencyCode": 1,
                  "classCode": 1,
                  "sourceId": "LEM",
                  "displayName": "LEAD Monthly",
                  "defaultConversionSourceId": null,
                  "autoRenewalExpirationInMonths": null,
                  "defaultSeatLimit": 6,
                  "auditId": "609dd865-633b-4c9c-89a4-164f945924d9",
                  "version": "AAAAAAJ+J4Y=",
                  "partner": null,
                  "registrationTenant": null,
                  "accountingRules": [],
                  "productPartitions": [],
                  "subscriptions": [
                     {
                        "$ref": "5"
                     }
                  ]
               },
               "subscriptionAuthorizations": [],
               "subscriptionConversionOptions": [],
               "subscriptionPaymentTransactionTransactions": [
                  {
                     "$ref": "1"
                  }
               ],
               "subscriptionSeats": []
            }
         },
         {
            "$id": "8",
            "id": 5472,
            "subscriptionId": 2260,
            "paymentTransactionId": 5484,
            "salesTaxAreaSourceId": null,
            "salesTaxRate": null,
            "salesTaxAmount": null,
            "auditId": "78e8aae3-5e6b-4466-a223-ff9a0f34ec6b",
            "paymentTransaction": {
               "$id": "9",
               "id": 5484,
               "paymentInstrumentId": 907,
               "paymentGatewayCode": 6,
               "typeCode": 2,
               "statusCode": 0,
               "amount": 99.0000,
               "sourceId": "dHJhbnNhY3Rpb25fbmczZGg3emo",
               "referenceSourceId": null,
               "paymentMerchantSourceId": "15",
               "responseMessage": "Approved",
               "responseRaw": "{\"id\":\"dHJhbnNhY3Rpb25fbmczZGg3emo\",\"legacyId\":\"ng3dh7zj\",\"createdAt\":\"2026-04-05T13:45:05.000000Z\",\"paymentMethodSnapshot\":{\"brandCode\":\"MASTERCARD\",\"last4\":\"4444\",\"bin\":\"555555\",\"expirationMonth\":\"12\",\"expirationYear\":\"2027\",\"cardholderName\":\"Aleah LeadTest\",\"uniqueNumberIdentifier\":\"60f13b8a1e4a24fe2bf9e19a732169d6\",\"origin\":null},\"paymentMethod\":{\"id\":\"cGF5bWVudG1ldGhvZF9jY19iZ3o5MXBhYg\",\"legacyId\":\"bgz91pab\",\"usage\":\"MULTI_USE\",\"createdAt\":\"2026-02-05T13:04:06.000000Z\",\"customer\":{\"id\":\"Y3VzdG9tZXJfMTg1MjY4NzM2NTM\",\"legacyId\":\"18526873653\",\"createdAt\":\"2026-02-05T13:04:06.000000Z\",\"email\":null,\"firstName\":null,\"lastName\":null,\"phoneNumber\":null}},\"amount\":{\"value\":99.00,\"currencyIsoCode\":\"USD\"},\"orderId\":\"54552816-202604\",\"purchaseOrderNumber\":null,\"status\":\"SUBMITTED_FOR_SETTLEMENT\",\"riskData\":null,\"descriptor\":null,\"statusHistory\":[{\"status\":\"SUBMITTED_FOR_SETTLEMENT\",\"timestamp\":\"2026-04-05T13:45:05.000000Z\",\"amount\":{\"value\":99.00,\"currencyIsoCode\":\"USD\"},\"source\":\"API\",\"terminal\":false,\"declineType\":null,\"gatewayRejectionReason\":null,\"processorResponse\":null},{\"status\":\"AUTHORIZED\",\"timestamp\":\"2026-04-05T13:45:05.000000Z\",\"amount\":{\"value\":99.00,\"currencyIsoCode\":\"USD\"},\"source\":\"API\",\"terminal\":false,\"declineType\":null,\"gatewayRejectionReason\":null,\"processorResponse\":{\"legacyCode\":\"1000\",\"message\":\"Approved\",\"cvvResponse\":\"NOT_PROVIDED\",\"avsPostalCodeResponse\":\"MATCHES\",\"avsStreetAddressResponse\":\"MATCHES\",\"authorizationId\":\"3560BH\"}}],\"merchantAccountId\":\"SWAdvantage_Residual_PaymentCard_USD\",\"channel\":null,\"source\":\"API\",\"customer\":{\"id\":\"Y3VzdG9tZXJfMTg1MjY4NzM2NTM\",\"legacyId\":\"18526873653\",\"createdAt\":\"2026-02-05T13:04:06.000000Z\",\"email\":null,\"firstName\":null,\"lastName\":null,\"phoneNumber\":null}}",
               "approvalCode": "3560BH",
               "effective": "4/5/2026 8:45:05 AM -05:00",
               "auditId": "8885929a-997a-4c95-a03b-a3341e3610c7",
               "version": "AAAAAAJ9MWY=",
               "paymentInstrument": {
                  "$id": "10",
                  "info": {
                     "currencyDescription": "America (United States of America), Dollars",
                     "currencyShortDescription": "$",
                     "typeDescription": "Payment Card",
                     "isTokenized": true,
                     "eft": null,
                     "card": {
                        "typeCode": 1,
                        "typeDescription": "MasterCard",
                        "typeLiteral": "MasterCard",
                        "cardholderName": "Aleah LeadTest",
                        "pan": "***4444",
                        "expiration": "12/31/2027 12:00:00 AM",
                        "cvv2": null
                     }
                  },
                  "id": 907,
                  "contactId": 3151,
                  "walletContactId": 3150,
                  "currencyCode": 1,
                  "typeCode": 2,
                  "sourceName": "MasterCard",
                  "lastFour": "4444",
                  "token": "cGF5bWVudG1ldGhvZF9jY19iZ3o5MXBhYg",
                  "tokenReference": "bgz91pab",
                  "tokenReceipt": "8d54b799-26a4-4edd-9b23-35d0e844b43e",
                  "tokenizationRequestTicket": "1381fcae-9675-43d7-9348-a6af5a271651",
                  "tokenized": "2/5/2026 7:04:06 AM -06:00",
                  "deactivated": null,
                  "auditId": "b2033f4d-6761-43a8-b825-d03954710599",
                  "version": "AAAAAAJ8Yhg=",
                  "contact": {
                     "$id": "11",
                     "info": {
                        "displayName": "",
                        "isLocalIdentity": false,
                        "nickname": null,
                        "userPrincipalId": null,
                        "userPrincipalName": null,
                        "userObjectIdentifier": null
                     },
                     "id": 3151,
                     "lastName": null,
                     "firstName": null,
                     "legalName": "Aleah LeadTest",
                     "emailAddress": null,
                     "canRegister": false,
                     "auditId": "4b5e6f47-d9e3-46f4-8d64-4ebd7daf26b5",
                     "version": "AAAAAAJ8YhU=",
                     "paymentInstrumentContact": {
                        "$ref": "10"
                     },
                     "contactAddresses": [],
                     "contactCertificates": [],
                     "contactIdentityClaims": [],
                     "contactPartitionProgresses": [],
                     "contentRegistrations": [],
                     "notifications": [],
                     "paymentInstrumentWalletContacts": [],
                     "profiles": []
                  },
                  "walletContact": null,
                  "eftRecord": null,
                  "paymentCard": {
                     "id": 642,
                     "paymentInstrumentId": 907,
                     "typeCode": 1,
                     "expiration": "12/31/2027 12:00:00 AM",
                     "paymentInstrument": {
                        "$ref": "10"
                     }
                  },
                  "paymentCardMaintenanceDetails": [],
                  "paymentTransactions": [
                     {
                        "$ref": "9"
                     }
                  ],
                  "subscriptionAuthorizations": []
               },
               "paymentTransactionIntegration": null,
               "subscriptionPaymentTransactionTransaction": {
                  "$ref": "8"
               }
            },
            "subscription": {
               "$id": "12",
               "info": {
                  "hasActiveSubscriptionAuthorization": false,
                  "isOnRenewalProbation": false,
                  "isPendingCancellation": false,
                  "isPendingPause": false,
                  "accountOwnerProfile": null,
                  "activeSubscriptionAuthorization": null,
                  "relevantSubscriptionAuthorization": null,
                  "subscriptionProductPartionContainerId": 0
               },
               "id": 2260,
               "accountId": 2069,
               "productId": 1,
               "productRegistered": "2/5/2026 12:00:00 AM",
               "referenceSourceId": "54552816",
               "sourceCode": 1,
               "partnerRepresentativeId": 40298,
               "statusCode": 1,
               "seatLimit": 6,
               "activated": "2/5/2026 7:19:05 AM -06:00",
               "lastPaymentAttempted": "5/6/2026 4:45:47 PM -05:00",
               "retryAttempts": 0,
               "nextPaymentDue": "6/5/2026 12:00:00 AM",
               "renewalProbationEffective": null,
               "expires": null,
               "cancelled": null,
               "cancellationEffective": null,
               "pausedUntil": null,
               "cancellationReasonCode": null,
               "cancellationSourceCode": null,
               "cancellationReasonText": null,
               "productVariantSourceId": null,
               "auditId": "cc40d18f-1ca6-4a63-b247-88d5a7949aba",
               "version": "AAAAAAJ+CFc=",
               "account": {
                  "$id": "13",
                  "info": {},
                  "id": 2069,
                  "partnerId": 131073,
                  "sourceId": "0b8b3ae5935c4256836725b3b8dd25de",
                  "ownerProfileSourceId": "8f696233684c4669a87ccc7cdda2a0f3",
                  "auditId": "3234d1d1-5912-4595-9377-9525eb9c0118",
                  "partner": null,
                  "profiles": [],
                  "subscriptions": [
                     {
                        "$ref": "12"
                     }
                  ]
               },
               "partnerRepresentative": null,
               "product": {
                  "$id": "14",
                  "info": {
                     "forRenewalOnly": false
                  },
                  "id": 1,
                  "partnerId": 131073,
                  "registrationTenantId": 2,
                  "billingFrequencyCode": 1,
                  "classCode": 1,
                  "sourceId": "LEM",
                  "displayName": "LEAD Monthly",
                  "defaultConversionSourceId": null,
                  "autoRenewalExpirationInMonths": null,
                  "defaultSeatLimit": 6,
                  "auditId": "609dd865-633b-4c9c-89a4-164f945924d9",
                  "version": "AAAAAAJ+J4Y=",
                  "partner": null,
                  "registrationTenant": null,
                  "accountingRules": [],
                  "productPartitions": [],
                  "subscriptions": [
                     {
                        "$ref": "12"
                     }
                  ]
               },
               "subscriptionAuthorizations": [],
               "subscriptionConversionOptions": [],
               "subscriptionPaymentTransactionTransactions": [
                  {
                     "$ref": "8"
                  }
               ],
               "subscriptionSeats": []
            }
         },
         {
            "$id": "15",
            "id": 5093,
            "subscriptionId": 2260,
            "paymentTransactionId": 5105,
            "salesTaxAreaSourceId": null,
            "salesTaxRate": null,
            "salesTaxAmount": null,
            "auditId": "70ad7bca-1101-44c4-834e-3f79f8dd0090",
            "paymentTransaction": {
               "$id": "16",
               "id": 5105,
               "paymentInstrumentId": 907,
               "paymentGatewayCode": 6,
               "typeCode": 2,
               "statusCode": 0,
               "amount": 99.0000,
               "sourceId": "dHJhbnNhY3Rpb25fODB5ZGhud2g",
               "referenceSourceId": null,
               "paymentMerchantSourceId": "15",
               "responseMessage": "Approved",
               "responseRaw": "{\"id\":\"dHJhbnNhY3Rpb25fODB5ZGhud2g\",\"legacyId\":\"80ydhnwh\",\"createdAt\":\"2026-03-05T14:45:07.000000Z\",\"paymentMethodSnapshot\":{\"brandCode\":\"MASTERCARD\",\"last4\":\"4444\",\"bin\":\"555555\",\"expirationMonth\":\"12\",\"expirationYear\":\"2027\",\"cardholderName\":\"Aleah LeadTest\",\"uniqueNumberIdentifier\":\"60f13b8a1e4a24fe2bf9e19a732169d6\",\"origin\":null},\"paymentMethod\":{\"id\":\"cGF5bWVudG1ldGhvZF9jY19iZ3o5MXBhYg\",\"legacyId\":\"bgz91pab\",\"usage\":\"MULTI_USE\",\"createdAt\":\"2026-02-05T13:04:06.000000Z\",\"customer\":{\"id\":\"Y3VzdG9tZXJfMTg1MjY4NzM2NTM\",\"legacyId\":\"18526873653\",\"createdAt\":\"2026-02-05T13:04:06.000000Z\",\"email\":null,\"firstName\":null,\"lastName\":null,\"phoneNumber\":null}},\"amount\":{\"value\":99.00,\"currencyIsoCode\":\"USD\"},\"orderId\":\"54552816-202603\",\"purchaseOrderNumber\":null,\"status\":\"SUBMITTED_FOR_SETTLEMENT\",\"riskData\":null,\"descriptor\":null,\"statusHistory\":[{\"status\":\"SUBMITTED_FOR_SETTLEMENT\",\"timestamp\":\"2026-03-05T14:45:08.000000Z\",\"amount\":{\"value\":99.00,\"currencyIsoCode\":\"USD\"},\"source\":\"API\",\"terminal\":false,\"declineType\":null,\"gatewayRejectionReason\":null,\"processorResponse\":null},{\"status\":\"AUTHORIZED\",\"timestamp\":\"2026-03-05T14:45:08.000000Z\",\"amount\":{\"value\":99.00,\"currencyIsoCode\":\"USD\"},\"source\":\"API\",\"terminal\":false,\"declineType\":null,\"gatewayRejectionReason\":null,\"processorResponse\":{\"legacyCode\":\"1000\",\"message\":\"Approved\",\"cvvResponse\":\"NOT_PROVIDED\",\"avsPostalCodeResponse\":\"MATCHES\",\"avsStreetAddressResponse\":\"MATCHES\",\"authorizationId\":\"2RX5MF\"}}],\"merchantAccountId\":\"SWAdvantage_Residual_PaymentCard_USD\",\"channel\":null,\"source\":\"API\",\"customer\":{\"id\":\"Y3VzdG9tZXJfMTg1MjY4NzM2NTM\",\"legacyId\":\"18526873653\",\"createdAt\":\"2026-02-05T13:04:06.000000Z\",\"email\":null,\"firstName\":null,\"lastName\":null,\"phoneNumber\":null}}",
               "approvalCode": "2RX5MF",
               "effective": "3/5/2026 8:45:07 AM -06:00",
               "auditId": "3639162c-fd03-4fb7-b7ab-b18da1f0a293",
               "version": "AAAAAAJ8al4=",
               "paymentInstrument": {
                  "$id": "17",
                  "info": {
                     "currencyDescription": "America (United States of America), Dollars",
                     "currencyShortDescription": "$",
                     "typeDescription": "Payment Card",
                     "isTokenized": true,
                     "eft": null,
                     "card": {
                        "typeCode": 1,
                        "typeDescription": "MasterCard",
                        "typeLiteral": "MasterCard",
                        "cardholderName": "Aleah LeadTest",
                        "pan": "***4444",
                        "expiration": "12/31/2027 12:00:00 AM",
                        "cvv2": null
                     }
                  },
                  "id": 907,
                  "contactId": 3151,
                  "walletContactId": 3150,
                  "currencyCode": 1,
                  "typeCode": 2,
                  "sourceName": "MasterCard",
                  "lastFour": "4444",
                  "token": "cGF5bWVudG1ldGhvZF9jY19iZ3o5MXBhYg",
                  "tokenReference": "bgz91pab",
                  "tokenReceipt": "8d54b799-26a4-4edd-9b23-35d0e844b43e",
                  "tokenizationRequestTicket": "1381fcae-9675-43d7-9348-a6af5a271651",
                  "tokenized": "2/5/2026 7:04:06 AM -06:00",
                  "deactivated": null,
                  "auditId": "b2033f4d-6761-43a8-b825-d03954710599",
                  "version": "AAAAAAJ8Yhg=",
                  "contact": {
                     "$id": "18",
                     "info": {
                        "displayName": "",
                        "isLocalIdentity": false,
                        "nickname": null,
                        "userPrincipalId": null,
                        "userPrincipalName": null,
                        "userObjectIdentifier": null
                     },
                     "id": 3151,
                     "lastName": null,
                     "firstName": null,
                     "legalName": "Aleah LeadTest",
                     "emailAddress": null,
                     "canRegister": false,
                     "auditId": "4b5e6f47-d9e3-46f4-8d64-4ebd7daf26b5",
                     "version": "AAAAAAJ8YhU=",
                     "paymentInstrumentContact": {
                        "$ref": "17"
                     },
                     "contactAddresses": [],
                     "contactCertificates": [],
                     "contactIdentityClaims": [],
                     "contactPartitionProgresses": [],
                     "contentRegistrations": [],
                     "notifications": [],
                     "paymentInstrumentWalletContacts": [],
                     "profiles": []
                  },
                  "walletContact": null,
                  "eftRecord": null,
                  "paymentCard": {
                     "id": 642,
                     "paymentInstrumentId": 907,
                     "typeCode": 1,
                     "expiration": "12/31/2027 12:00:00 AM",
                     "paymentInstrument": {
                        "$ref": "17"
                     }
                  },
                  "paymentCardMaintenanceDetails": [],
                  "paymentTransactions": [
                     {
                        "$ref": "16"
                     }
                  ],
                  "subscriptionAuthorizations": []
               },
               "paymentTransactionIntegration": null,
               "subscriptionPaymentTransactionTransaction": {
                  "$ref": "15"
               }
            },
            "subscription": {
               "$id": "19",
               "info": {
                  "hasActiveSubscriptionAuthorization": false,
                  "isOnRenewalProbation": false,
                  "isPendingCancellation": false,
                  "isPendingPause": false,
                  "accountOwnerProfile": null,
                  "activeSubscriptionAuthorization": null,
                  "relevantSubscriptionAuthorization": null,
                  "subscriptionProductPartionContainerId": 0
               },
               "id": 2260,
               "accountId": 2069,
               "productId": 1,
               "productRegistered": "2/5/2026 12:00:00 AM",
               "referenceSourceId": "54552816",
               "sourceCode": 1,
               "partnerRepresentativeId": 40298,
               "statusCode": 1,
               "seatLimit": 6,
               "activated": "2/5/2026 7:19:05 AM -06:00",
               "lastPaymentAttempted": "5/6/2026 4:45:47 PM -05:00",
               "retryAttempts": 0,
               "nextPaymentDue": "6/5/2026 12:00:00 AM",
               "renewalProbationEffective": null,
               "expires": null,
               "cancelled": null,
               "cancellationEffective": null,
               "pausedUntil": null,
               "cancellationReasonCode": null,
               "cancellationSourceCode": null,
               "cancellationReasonText": null,
               "productVariantSourceId": null,
               "auditId": "cc40d18f-1ca6-4a63-b247-88d5a7949aba",
               "version": "AAAAAAJ+CFc=",
               "account": {
                  "$id": "20",
                  "info": {},
                  "id": 2069,
                  "partnerId": 131073,
                  "sourceId": "0b8b3ae5935c4256836725b3b8dd25de",
                  "ownerProfileSourceId": "8f696233684c4669a87ccc7cdda2a0f3",
                  "auditId": "3234d1d1-5912-4595-9377-9525eb9c0118",
                  "partner": null,
                  "profiles": [],
                  "subscriptions": [
                     {
                        "$ref": "19"
                     }
                  ]
               },
               "partnerRepresentative": null,
               "product": {
                  "$id": "21",
                  "info": {
                     "forRenewalOnly": false
                  },
                  "id": 1,
                  "partnerId": 131073,
                  "registrationTenantId": 2,
                  "billingFrequencyCode": 1,
                  "classCode": 1,
                  "sourceId": "LEM",
                  "displayName": "LEAD Monthly",
                  "defaultConversionSourceId": null,
                  "autoRenewalExpirationInMonths": null,
                  "defaultSeatLimit": 6,
                  "auditId": "609dd865-633b-4c9c-89a4-164f945924d9",
                  "version": "AAAAAAJ+J4Y=",
                  "partner": null,
                  "registrationTenant": null,
                  "accountingRules": [],
                  "productPartitions": [],
                  "subscriptions": [
                     {
                        "$ref": "19"
                     }
                  ]
               },
               "subscriptionAuthorizations": [],
               "subscriptionConversionOptions": [],
               "subscriptionPaymentTransactionTransactions": [
                  {
                     "$ref": "15"
                  }
               ],
               "subscriptionSeats": []
            }
         },
         {
            "$id": "22",
            "id": 4730,
            "subscriptionId": 2260,
            "paymentTransactionId": 4742,
            "salesTaxAreaSourceId": null,
            "salesTaxRate": null,
            "salesTaxAmount": null,
            "auditId": "a9ad51b8-3d17-4902-8fda-52975d5632c2",
            "paymentTransaction": {
               "$id": "23",
               "id": 4742,
               "paymentInstrumentId": 907,
               "paymentGatewayCode": 6,
               "typeCode": 2,
               "statusCode": 0,
               "amount": 99.0000,
               "sourceId": "dHJhbnNhY3Rpb25fN3ZndHd4ZGs",
               "referenceSourceId": null,
               "paymentMerchantSourceId": "15",
               "responseMessage": "Approved",
               "responseRaw": "{\"id\":\"dHJhbnNhY3Rpb25fN3ZndHd4ZGs\",\"legacyId\":\"7vgtwxdk\",\"createdAt\":\"2026-02-05T13:19:12.000000Z\",\"paymentMethodSnapshot\":{\"brandCode\":\"MASTERCARD\",\"last4\":\"4444\",\"bin\":\"555555\",\"expirationMonth\":\"12\",\"expirationYear\":\"2027\",\"cardholderName\":\"Aleah LeadTest\",\"uniqueNumberIdentifier\":\"60f13b8a1e4a24fe2bf9e19a732169d6\",\"origin\":null},\"paymentMethod\":{\"id\":\"cGF5bWVudG1ldGhvZF9jY19iZ3o5MXBhYg\",\"legacyId\":\"bgz91pab\",\"usage\":\"MULTI_USE\",\"createdAt\":\"2026-02-05T13:04:06.000000Z\",\"customer\":{\"id\":\"Y3VzdG9tZXJfMTg1MjY4NzM2NTM\",\"legacyId\":\"18526873653\",\"createdAt\":\"2026-02-05T13:04:06.000000Z\",\"email\":null,\"firstName\":null,\"lastName\":null,\"phoneNumber\":null}},\"amount\":{\"value\":99.00,\"currencyIsoCode\":\"USD\"},\"orderId\":\"54552816-202602\",\"purchaseOrderNumber\":null,\"status\":\"SUBMITTED_FOR_SETTLEMENT\",\"riskData\":null,\"descriptor\":null,\"statusHistory\":[{\"status\":\"SUBMITTED_FOR_SETTLEMENT\",\"timestamp\":\"2026-02-05T13:19:12.000000Z\",\"amount\":{\"value\":99.00,\"currencyIsoCode\":\"USD\"},\"source\":\"API\",\"terminal\":false,\"declineType\":null,\"gatewayRejectionReason\":null,\"processorResponse\":null},{\"status\":\"AUTHORIZED\",\"timestamp\":\"2026-02-05T13:19:12.000000Z\",\"amount\":{\"value\":99.00,\"currencyIsoCode\":\"USD\"},\"source\":\"API\",\"terminal\":false,\"declineType\":null,\"gatewayRejectionReason\":null,\"processorResponse\":{\"legacyCode\":\"1000\",\"message\":\"Approved\",\"cvvResponse\":\"NOT_PROVIDED\",\"avsPostalCodeResponse\":\"MATCHES\",\"avsStreetAddressResponse\":\"MATCHES\",\"authorizationId\":\"KJLHTF\"}}],\"merchantAccountId\":\"SWAdvantage_Residual_PaymentCard_USD\",\"channel\":null,\"source\":\"API\",\"customer\":{\"id\":\"Y3VzdG9tZXJfMTg1MjY4NzM2NTM\",\"legacyId\":\"18526873653\",\"createdAt\":\"2026-02-05T13:04:06.000000Z\",\"email\":null,\"firstName\":null,\"lastName\":null,\"phoneNumber\":null}}",
               "approvalCode": "KJLHTF",
               "effective": "2/5/2026 7:19:12 AM -06:00",
               "auditId": "2194ad23-5e84-4683-8b1a-264c14eabafa",
               "version": "AAAAAAJ8Yh0=",
               "paymentInstrument": {
                  "$id": "24",
                  "info": {
                     "currencyDescription": "America (United States of America), Dollars",
                     "currencyShortDescription": "$",
                     "typeDescription": "Payment Card",
                     "isTokenized": true,
                     "eft": null,
                     "card": {
                        "typeCode": 1,
                        "typeDescription": "MasterCard",
                        "typeLiteral": "MasterCard",
                        "cardholderName": "Aleah LeadTest",
                        "pan": "***4444",
                        "expiration": "12/31/2027 12:00:00 AM",
                        "cvv2": null
                     }
                  },
                  "id": 907,
                  "contactId": 3151,
                  "walletContactId": 3150,
                  "currencyCode": 1,
                  "typeCode": 2,
                  "sourceName": "MasterCard",
                  "lastFour": "4444",
                  "token": "cGF5bWVudG1ldGhvZF9jY19iZ3o5MXBhYg",
                  "tokenReference": "bgz91pab",
                  "tokenReceipt": "8d54b799-26a4-4edd-9b23-35d0e844b43e",
                  "tokenizationRequestTicket": "1381fcae-9675-43d7-9348-a6af5a271651",
                  "tokenized": "2/5/2026 7:04:06 AM -06:00",
                  "deactivated": null,
                  "auditId": "b2033f4d-6761-43a8-b825-d03954710599",
                  "version": "AAAAAAJ8Yhg=",
                  "contact": {
                     "$id": "25",
                     "info": {
                        "displayName": "",
                        "isLocalIdentity": false,
                        "nickname": null,
                        "userPrincipalId": null,
                        "userPrincipalName": null,
                        "userObjectIdentifier": null
                     },
                     "id": 3151,
                     "lastName": null,
                     "firstName": null,
                     "legalName": "Aleah LeadTest",
                     "emailAddress": null,
                     "canRegister": false,
                     "auditId": "4b5e6f47-d9e3-46f4-8d64-4ebd7daf26b5",
                     "version": "AAAAAAJ8YhU=",
                     "paymentInstrumentContact": {
                        "$ref": "24"
                     },
                     "contactAddresses": [],
                     "contactCertificates": [],
                     "contactIdentityClaims": [],
                     "contactPartitionProgresses": [],
                     "contentRegistrations": [],
                     "notifications": [],
                     "paymentInstrumentWalletContacts": [],
                     "profiles": []
                  },
                  "walletContact": null,
                  "eftRecord": null,
                  "paymentCard": {
                     "id": 642,
                     "paymentInstrumentId": 907,
                     "typeCode": 1,
                     "expiration": "12/31/2027 12:00:00 AM",
                     "paymentInstrument": {
                        "$ref": "24"
                     }
                  },
                  "paymentCardMaintenanceDetails": [],
                  "paymentTransactions": [
                     {
                        "$ref": "23"
                     }
                  ],
                  "subscriptionAuthorizations": []
               },
               "paymentTransactionIntegration": null,
               "subscriptionPaymentTransactionTransaction": {
                  "$ref": "22"
               }
            },
            "subscription": {
               "$id": "26",
               "info": {
                  "hasActiveSubscriptionAuthorization": false,
                  "isOnRenewalProbation": false,
                  "isPendingCancellation": false,
                  "isPendingPause": false,
                  "accountOwnerProfile": null,
                  "activeSubscriptionAuthorization": null,
                  "relevantSubscriptionAuthorization": null,
                  "subscriptionProductPartionContainerId": 0
               },
               "id": 2260,
               "accountId": 2069,
               "productId": 1,
               "productRegistered": "2/5/2026 12:00:00 AM",
               "referenceSourceId": "54552816",
               "sourceCode": 1,
               "partnerRepresentativeId": 40298,
               "statusCode": 1,
               "seatLimit": 6,
               "activated": "2/5/2026 7:19:05 AM -06:00",
               "lastPaymentAttempted": "5/6/2026 4:45:47 PM -05:00",
               "retryAttempts": 0,
               "nextPaymentDue": "6/5/2026 12:00:00 AM",
               "renewalProbationEffective": null,
               "expires": null,
               "cancelled": null,
               "cancellationEffective": null,
               "pausedUntil": null,
               "cancellationReasonCode": null,
               "cancellationSourceCode": null,
               "cancellationReasonText": null,
               "productVariantSourceId": null,
               "auditId": "cc40d18f-1ca6-4a63-b247-88d5a7949aba",
               "version": "AAAAAAJ+CFc=",
               "account": {
                  "$id": "27",
                  "info": {},
                  "id": 2069,
                  "partnerId": 131073,
                  "sourceId": "0b8b3ae5935c4256836725b3b8dd25de",
                  "ownerProfileSourceId": "8f696233684c4669a87ccc7cdda2a0f3",
                  "auditId": "3234d1d1-5912-4595-9377-9525eb9c0118",
                  "partner": null,
                  "profiles": [],
                  "subscriptions": [
                     {
                        "$ref": "26"
                     }
                  ]
               },
               "partnerRepresentative": null,
               "product": {
                  "$id": "28",
                  "info": {
                     "forRenewalOnly": false
                  },
                  "id": 1,
                  "partnerId": 131073,
                  "registrationTenantId": 2,
                  "billingFrequencyCode": 1,
                  "classCode": 1,
                  "sourceId": "LEM",
                  "displayName": "LEAD Monthly",
                  "defaultConversionSourceId": null,
                  "autoRenewalExpirationInMonths": null,
                  "defaultSeatLimit": 6,
                  "auditId": "609dd865-633b-4c9c-89a4-164f945924d9",
                  "version": "AAAAAAJ+J4Y=",
                  "partner": null,
                  "registrationTenant": null,
                  "accountingRules": [],
                  "productPartitions": [],
                  "subscriptions": [
                     {
                        "$ref": "26"
                     }
                  ]
               },
               "subscriptionAuthorizations": [],
               "subscriptionConversionOptions": [],
               "subscriptionPaymentTransactionTransactions": [
                  {
                     "$ref": "22"
                  }
               ],
               "subscriptionSeats": []
            }
         }
      ] as unknown as ISubscriptionPaymentTransaction[]
   }

   public getSubscriptionConversionOptions(): ISubscriptionConversionOption[] {
      return [
         {
            "id": 1913,
            "subscriptionId": 2410,
            "productSourceId": "LEM",
            "productDisplayName": "LEAD Monthly",
            "billingFrequencyCode": 1,
            "subscriptionAuthorizationAmount": 199.0000,
            "autoRenewalExpirationInMonths": null,
            "isPlanned": true,
            "auditId": "5536f505-4ebb-43be-aee6-50374bc6a793",
            "version": "AAAAAAJ+Jz8="
         },
         {
            "id": 1914,
            "subscriptionId": 2410,
            "productSourceId": "LEA",
            "productDisplayName": "LEAD Annual",
            "billingFrequencyCode": 4,
            "subscriptionAuthorizationAmount": 1995.0000,
            "autoRenewalExpirationInMonths": 12,
            "isPlanned": false,
            "auditId": "20901f0f-6c6b-4863-a0ff-a498aa7fee6f",
            "version": "AAAAAAJ+J0A="
         },
         {
            "id": 1915,
            "subscriptionId": 2410,
            "productSourceId": "LES",
            "productDisplayName": "LEAD Semi-Annual",
            "billingFrequencyCode": 7,
            "subscriptionAuthorizationAmount": 995.0000,
            "autoRenewalExpirationInMonths": 6,
            "isPlanned": false,
            "auditId": "6dd31b7a-fcd2-4eeb-bbeb-b0aca721a2d4",
            "version": "AAAAAAJ+J0E="
         }
      ] as unknown as ISubscriptionConversionOption[]
   }
}
